import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import forward from '../../Assets/next-arrow.png'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import {
  FiArrowUpRight,
  FiAward,
  FiLayers,
  FiUsers,
  FiZap
} from "react-icons/fi";

import Navbar from "../../Components/Navbar/Navbar";
import ContactCTA from "../../Components/ContactCTA/ContactCTA";
import Footer from "../../Components/Footer/Footer";

import "./AboutPage.css";
const stats = [
  {
    number: 120,
    suffix: "+",
    label: "Projects Delivered"
  },
  {
    number: 45,
    suffix: "+",
    label: "Creative Partners"
  },
  {
    number: 12,
    suffix: "",
    label: "Industry Verticals"
  },
  {
    number: 100,
    suffix: "%",
    label: "Creative Commitment"
  }
];

const principles = [
  {
    icon: <FiZap />,
    title: "Creative First",
    description:
      "Every project begins with an idea worth remembering before production starts."
  },
  {
    icon: <FiLayers />,
    title: "Strategy Driven",
    description:
      "Great visuals come from thoughtful planning and meaningful creative direction."
  },
  {
    icon: <FiUsers />,
    title: "Collaboration",
    description:
      "We work closely with our clients throughout every stage of the creative process."
  },
  {
    icon: <FiAward />,
    title: "Craftsmanship",
    description:
      "Every frame, transition and interaction is refined with attention to detail."
  }
];

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -80
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 80
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};


function AboutPage() {
  const { ref, inView } = useInView({
  triggerOnce: true,
  threshold: 0.3
});
  return (
    <>
      <Navbar />

      <main className="about-page">

        {/* ==========================================
            HERO
        ========================================== */}

        <section className="about-hero">

          <div className="about-hero-glow"></div>

          <div className="about-container">

          

            <motion.h1
              className="about-title"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              About Us 
            </motion.h1>

            <motion.p
              className="about-description"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              ETOE Productions is a creative agency that helps businesses grow through branding,
               design, websites, marketing, and creative content
            </motion.p>

            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="about-hero-actions"
            >
              <Link to="/contact" className="about-primary-btn">
                Start Your Project
                <img src={forward} alt="arrow" className="cta-arrow" />
              </Link>
            </motion.div>

            

          </div>

        </section>

        {/* ==========================================
            WHO WE ARE
        ========================================== */}

        <section className="about-story">

          <div className="about-container">

            <div className="about-story-grid">

              <motion.div
                className="about-story-image"
                variants={fadeLeft}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <img
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=90"
                  alt="Creative Team"
                />
              </motion.div>

              <motion.div
                className="about-story-content"
                variants={fadeRight}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <span className="section-label">
                  WHO WE ARE
                </span>

                <h2>
                 Creative Ideas | Real Business Growth
                  
                </h2>

                <p>
                  ETOE Productions is a creative agency that turns ideas into
                   impactful brands and digital experiences. From branding and
                  content creation to websites, marketing,and production, we help
                   businesses stand out, connect with their audience, and grow with confidence
                </p>

                <p>
                Every project begins with your vision. We work closely with you to create solutions that
               are creative, effective, and focused on delivering real results
                </p>

                <Link
                  to="/services"
                  className="about-link"
                >
                  Explore Our Services
                  <FiArrowUpRight />
                </Link>

              </motion.div>

            </div>

          </div>

        </section>
                {/* ==========================================
            OUR NUMBERS
        ========================================== */}

        <section className="about-stats"  ref={ref}>

          <div className="about-container">

            <motion.div
              className="section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >


              <h2>
                Driven By
                <span>Creative Excellence</span>
              </h2>

            </motion.div>

            <div className="about-stats-grid">

              {stats.map((item, index) => (

                <motion.div
                  key={index}
                  className="about-stat-card"
                  initial={{
                    opacity: 0,
                    y: 40
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0
                  }}
                  transition={{
                    delay: index * 0.15,
                    duration: 0.7
                  }}
                  viewport={{ once: true }}
                  whileHover={{
                    y: -8
                  }}
                >

                  <h3>
                      {inView && (
                        <CountUp
                          start={0}
                          end={item.number}
                          duration={2.8}
                          delay={0.2}
                          useEasing
                          easingFn={(t, b, c, d) => {
                            t /= d;
                            return -c * t * (t - 2) + b;
                          }}
                        />
                      )}
                      {item.suffix}
                    </h3>

                  <p>{item.label}</p>

                </motion.div>

              ))}

            </div>

          </div>

        </section>

        {/* ==========================================
            PRINCIPLES
        ========================================== */}

        <section className="about-principles">

          <div className="about-container">

            <motion.div
              className="section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >

          

              <h2>
                Everything We
                <span>Believe In</span>
              </h2>

            </motion.div>

            <div className="about-principles-grid">

              {principles.map((item, index) => (

                <motion.article
                  key={index}
                  className="principle-card"
                  initial={{
                    opacity: 0,
                    y: 60
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0
                  }}
                  transition={{
                    delay: index * 0.15,
                    duration: 0.75
                  }}
                  viewport={{ once: true }}
                  whileHover={{
                    y: -10
                  }}
                >

                  <div className="principle-icon">

                    {item.icon}

                  </div>

                  <h3>

                    {item.title}

                  </h3>

                  <p>

                    {item.description}

                  </p>


                </motion.article>

              ))}

            </div>

          </div>

        </section>

      </main>

      <ContactCTA />

      <Footer />

    </>
  );
}

export default AboutPage;